import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

type ServiceMenuItem = {
  key: string
  label: string
  description: string
  route: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CareerAiServiceMenu',
  props: {
  // メニュー項目。文言・遷移先の正本は utils/ai/careerChatMenu.json
  items: { type: Array as () => ServiceMenuItem[], default: () => [] }
},
  emits: ['select', 'close'],
  setup(__props, { expose }) {




const closeButton = ref<HTMLButtonElement | null>(null)

// 開いた直後にフォーカスをパネル内へ移すため、親から呼ぶ。
// ＋ボタンは v-if で消えるので、移さないとフォーカスが body へ落ちて
// キーボードではメニューに到達できなくなる。**見た目のリングは
// :focus-visible 側で抑える**（マウスで開いたときに枠を出さない）
const focusClose = (): void => {
  closeButton.value?.focus()
}

expose({ focusClose })

return { __sfc: true,closeButton, focusClose }
}

})